import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { useEffect } from 'react';
import { trackShowForecastTypePermissionError } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const ForecastTypePermissionError = ({
  isDetail
}) => {
  useEffect(() => {
    trackShowForecastTypePermissionError(isDetail);
  }, [isDetail]);
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "start",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(Box, {
      basis: 700,
      shrink: 0,
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "forecastType.noForecastPermissionsTitle"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "forecastType.noForecastPermissionsBody"
        })
      })
    })
  });
};